import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from '../componentes/dashboard/dashboard'
import { Header } from '../componentes/header/header';
import Menu from '../componentes/menu/menu';
import { ModalChangePassword } from '../componentes/modalChangePassword/ModalChangePassword';
import { ModalCommissions } from '../componentes/modalCommissions/ModalCommissions';
import { ModalDepositAccounts } from '../componentes/modalDepositAccounts/ModalDepositAccounts';
import { ModalMovements } from '../componentes/modalMov/ModalMovements';
import { ModalSessionTime } from '../componentes/modalSessionTime/ModalSessionTime';
import { ModalVentas } from '../componentes/modalventas/ModalVentas';
import { ModalHelp } from '../componentes/modal_help/ModalHelp';
import { PinesUsuarios } from '../componentes/pines-usuarios/PinesUsuarios'
import { ModalTwoFactor } from '../componentes/ModalTwoFactor/ModalTwoFactor';
import { useSelector } from 'react-redux';
import { LoadingScreen } from '../componentes/Layout/LoadingScreen';

export const DashboardRoutes = () => {
  const { isLoadingActive } = useSelector((s) => s.uiState);

  return (
    <>
      {(isLoadingActive) &&
        < LoadingScreen />
      }
      <div className="container bg-white">
        <Menu />
        <div className="row gradientBlue">
          <div className="col-12">
            <Header />
          </div>
        </div>
        <main>
          <div className='bdash'>
            <Routes>
              <Route path="/" element={<Dashboard />}></Route>
              <Route path="/home" element={<Dashboard />}></Route>
              <Route path='/pines-usuarios' element={<PinesUsuarios />}></Route>
              <Route path='*' element={<Navigate to='/home' />}></Route>
            </Routes>
          </div>
        </main>
        <ModalHelp />
        <ModalDepositAccounts />
        <ModalCommissions />
        <ModalChangePassword />
        <ModalSessionTime />
        <ModalVentas />
        <ModalMovements />
        <ModalTwoFactor />
      </div>
    </>
  )
}